module.exports = __webpack_public_path__ + "img/shadows-and-gradients.c39f1652.png";